import React from 'react';
import { Helmet } from 'react-helmet';

const SocialProfileSchema = () => {
  const socialProfileData = {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "mainEntity": {
      "@type": "Organization",
      "@id": "https://www.tensorpilot.io/#organization",
      "name": "TensorPilot",
      "url": "https://www.tensorpilot.io/",
      "sameAs": [
        "https://x.com/Tensor_Pilot", // Update with actual social media URLs
        "https://www.linkedin.com/company/tensor-pilot",
        "https://youtube.com/@tensor-pilot"
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(socialProfileData)}
      </script>
    </Helmet>
  );
};

export default SocialProfileSchema;
